module.exports = __webpack_public_path__ + "static/img/王晨A.a5a84abc.png";